// Charts
import { defineAsyncComponent } from 'vue'

export const SlotModalComponent = defineAsyncComponent(() => import('./slot-modal-component.vue'))